export default "__VITE_ASSET__D$_RrEiX__"